import { create } from 'zustand';

import { type TypeDecodedToken, type TypePermissions, checkPermission } from '~/utils';

type TypeUserStoreState = {
  userInfo: TypeDecodedToken;
};

type TypeUserStoreActions = {
  setUserInfo: (userInfo: TypeDecodedToken) => void;
  resetUserInfo: () => void;

  hasPermission: (permissions: TypePermissions) => boolean;
};

type TypeUserStore = TypeUserStoreState & TypeUserStoreActions;

export const initialUserStoreValue: TypeUserStoreState = {
  userInfo: {
    loginId: '',
    name: '',
    ownerCode: '',
    ownerName: '',
    ownerType: null,
    logisticsTypes: [],
    userClass: 'NORMAL',
  },
};

/**
 * 토큰 디코딩 결과 사용자 정보를 관리하기 위한 스토어
 */
export const useUserInfoStore = create<TypeUserStore>((set, get) => ({
  ...initialUserStoreValue,

  setUserInfo: (userInfo) => set({ userInfo }),

  resetUserInfo: () => set({ userInfo: initialUserStoreValue.userInfo }),

  hasPermission: (permissions) => {
    const { ownerType, logisticsTypes } = get().userInfo;
    return checkPermission(ownerType, logisticsTypes, permissions);
  },
}));
